import {
  IUpdateOffersData,
  UPDATE_OFFERS_DATA,
  IToggleLoadingGetOffersData,
  TOGGLE_LOADING_GETOFFERS,
  UPDATE_HOME_SEO_DATA,
  IUpdateSEOData,
  ISeoData,
  UPDATE_CAMPAIGN_DATA,
  IUpdateCampaignData,
  TOGGLE_LOADING_CAMPAIGN,
  ICampaignloading,
  UPDATE_HEAD_CAMPAIGN_DATA,
  IUpdateCampaignHeadData
} from './types';

export function updateSEOData(homeSeoData: ISeoData): IUpdateSEOData {
  return {
    type: UPDATE_HOME_SEO_DATA,
    homeSeoData,
  };
}

export function updateOffersDataAction(
  actionData: IUpdateOffersData['actionData'],
): IUpdateOffersData {
  return {
    type: UPDATE_OFFERS_DATA,
    actionData,
  };
}

export function toggleLoadingGetOffersAction(
  actionData: IToggleLoadingGetOffersData['actionData'],
): IToggleLoadingGetOffersData {
  return {
    type: TOGGLE_LOADING_GETOFFERS,
    actionData,
  };
}

export function campaingDataAction(
  actionData: IUpdateCampaignData['actionData'],
): IUpdateCampaignData {
  return {
    type: UPDATE_CAMPAIGN_DATA,
    actionData
  }
}

export function toggleLoadingCamapaignAction(
  actionData: ICampaignloading['actionData'],
): ICampaignloading{
  return {
    type: TOGGLE_LOADING_CAMPAIGN,
    actionData
  }
}

export function updateCampaignHeadData(
  actionData: IUpdateCampaignHeadData['actionData'],
): IUpdateCampaignHeadData{
  return {
    type: UPDATE_HEAD_CAMPAIGN_DATA,
    actionData
  }
}
